import { render, staticRenderFns } from "./pos-box-table.vue?vue&type=template&id=24fe21aa&scoped=true&"
import script from "./pos-box-table.ts?vue&type=script&lang=ts&"
export * from "./pos-box-table.ts?vue&type=script&lang=ts&"
import style0 from "./pos-box-table.scss?vue&type=style&index=0&id=24fe21aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe21aa",
  null
  
)

export default component.exports